import { SubscriptionProductItem } from '../../../utils/subscriptionDetail/types';
import { QuantityUpdate } from '../../../hooks/use-product-cart';
import styles from '../../../assets/scss/SubscriptionDetail/NextDeliverySubscription/SubscriptionProduct.module.scss';
import { postMessageGtag } from '../../../utils/trackClick';
import { QuantitySelect } from '../../QuantitySelect/QuantitySelect';

type Props = {
  column: number;
  product: SubscriptionProductItem;
  quantity: number;
  changeQuantity: (updates: QuantityUpdate) => void;
};

export function ProductTotals({ column, product, quantity, changeQuantity }: Props) {
  const { currentPriceAmount, choices, displayUnit } = product;

  const onChange = (value: number) => {
    changeQuantity({ product, newQty: value });
    postMessageGtag('click_number_' + product.handle, 'detailProducts');
  };

  const onDelete = () => {
    if (quantity === 0) return;
    changeQuantity({ product, newQty: 0 });
    postMessageGtag('click_delete_' + product.handle, 'detailProducts');
  };

  const total = currentPriceAmount * quantity;
  const disabled = quantity === 0;

  if (column === 1) {
    return (
      <div className={styles.totals}>
        {/* 選択肢 */}
        <Choices
          quantity={quantity}
          choices={choices}
          displayUnit={displayUnit}
          onChange={onChange}
        />

        {/* 削除ボタン */}
        <DeleteBtn
          disabled={disabled}
          onDelete={onDelete}
        />

        {/* 単品合計 */}
        <TotalPrice total={total} />
      </div>
    );
  }

  return (
    <div className={styles.totals}>
      {/* 選択肢 */}
      <Choices
        quantity={quantity}
        choices={choices}
        displayUnit={displayUnit}
        onChange={onChange}
      />

      {/* 単品合計 */}
      <TotalPrice total={total} />

      {/* 削除ボタン */}
      <DeleteBtn
        disabled={disabled}
        onDelete={onDelete}
      />
    </div>
  );
}

type ChoicesProps = {
  quantity: number;
  choices: number[];
  displayUnit: string;
  onChange: (value: number) => void;
};

function Choices({ quantity, choices, displayUnit, onChange }: ChoicesProps) {
  return (
    <div className={styles.choicesWrapper}>
      <div className={styles.choices}>
        <QuantitySelect
          value={quantity}
          choices={choices}
          onChange={onChange}
          triggerClassName={styles.selectTrigger}
        />
      </div>
      <span className={styles.unit}>{displayUnit}</span>
    </div>
  );
}

type DeleteBtnProps = {
  disabled: boolean;
  onDelete: () => void;
};

function DeleteBtn({ disabled, onDelete }: DeleteBtnProps) {
  return (
    <button
      className={styles.deleteBtn}
      onClick={onDelete}
      disabled={disabled}
    >
      削除
    </button>
  );
}

type TotalPriceProps = {
  total: number;
};

function TotalPrice({ total }: TotalPriceProps) {
  return (
    <div className={styles.totalPrice}>
      <span className={styles.currency}>¥</span>
      <span className={styles.amount}>{total.toLocaleString()}</span>
    </div>
  );
}
